import React from "react";

export interface TerminalLocationProps {
  locationCode?: string | null;
  className?: string;
}

function formatLocationCode(locationCode: string): string {
  const normalized = locationCode.toString().trim().toUpperCase();
  if (!normalized) return "—";
  return normalized.startsWith("D-") ? normalized : `D-${normalized}`;
}

const TerminalLocation: React.FC<TerminalLocationProps> = ({ locationCode, className }) => {
  if (locationCode == null || locationCode === "") {
    return <span className={className}>—</span>;
  }
  return <span className={className}>{formatLocationCode(locationCode)}</span>;
};

export default TerminalLocation;
